import React, { useCallback, useEffect, useState } from 'react';
import { NavContainer } from './styles/navbar.style';

import PropTypes from 'prop-types';
import DesktopNavbar from './components/DesktopNavar';
import { useMediaQuery } from '@mui/material';
import MobileNavbar from './components/MobileNavbar';
import { DROPDOWN_CATEGORIES, DROPDOWN_MENU_ITEMS } from './constants';
import { useModal } from '../../context/ModalContext';

const Navbar = ({ isHomePage, getStartedCtaLink }) => {
    const [activeMenu, setActiveMenu] = useState('');
    const [activeSubMenu, setActiveSubMenu] = useState('');
    const [currentPath, setCurrentPath] = useState('');
    const [activeDropdownCategory, setActiveDropdownCategory] = useState('');

    const { openModal } = useModal();

    const dropdownCategories = DROPDOWN_CATEGORIES[activeMenu];
    const menuItems = DROPDOWN_MENU_ITEMS[activeMenu];

    const isSmallScreen = useMediaQuery('(max-width: 860px)');

    const getActiveCategoryFromPath = useCallback(() => {
        for (const [, category] of Object.entries(dropdownCategories)) {
            const items = menuItems[category.label] || [];

            if (items.some((item) => item.link === currentPath)) {
                return category.label;
            }
        }
        return isSmallScreen ? null : Object.values(dropdownCategories)[0]?.label;
    }, [currentPath, menuItems, dropdownCategories, isSmallScreen]);

    useEffect(() => {
        if (dropdownCategories) {
            setActiveDropdownCategory(getActiveCategoryFromPath());
        }
    }, [getActiveCategoryFromPath, dropdownCategories]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setCurrentPath(window.location.pathname);
        }
    }, []);

    const commonProps = {
        isHomePage,
        getStartedCtaLink,
        activeMenu,
        setActiveMenu,
        activeSubMenu,
        setActiveSubMenu,
        dropdownCategories,
        menuItems,
        currentPath,
        openModal,
        activeDropdownCategory,
        setActiveDropdownCategory,
    };
    return (
        <NavContainer>
            {isSmallScreen ? <MobileNavbar {...commonProps} /> : <DesktopNavbar {...commonProps} />}
        </NavContainer>
    );
};

Navbar.propTypes = {
    isHomePage: PropTypes.bool,
    getStartedCtaLink: PropTypes.string,
};

export default Navbar;
